/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsGraphionScoreQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsGraphionScoreQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsGraphionScoreQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsGraphionScoreQueryOperator>): AppSecopsGraphionScoreQueryOperator {
        let obj = Object.assign(new AppSecopsGraphionScoreQueryOperator(), model);
        AppSecopsGraphionScoreQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsGraphionScoreQueryOperator>): AppSecopsGraphionScoreQueryOperator {
        if (!model) return null;
        return AppSecopsGraphionScoreQueryOperator.newInstance(<AppSecopsGraphionScoreQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsGraphionScoreQueryOperator) {
        if (!obj) return;

        models.AppSecopsGraphionScoreQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsGraphionScoreQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsGraphionScoreQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.graphion_score === undefined) {
            this.graphion_score = 0;
        }
    }

    /**
     * Graphion score associated with the vulnerability
     */
    graphion_score: number;

}
